<template>
  <section class="vcr-ledger">
    <header class="vcr-ledger__header">
      <h3>{{ title }}</h3>
      <span v-if="tag" class="vcr-ledger__tag">{{ tag }}</span>
    </header>
    <table class="vcr-ledger__table">
      <colgroup>
        <col />
        <col class="vcr-ledger__col-code" />
        <col class="vcr-ledger__col-amount" />
        <col class="vcr-ledger__col-amount" />
        <col class="vcr-ledger__col-amount" />
        <col class="vcr-ledger__col-pct" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ i18n.t('/Vcr/Autoline/Part Label') }}</th>
          <th>{{ i18n.t('/Vcr/Autoline/Code Label') }}</th>
          <th class="r">{{ i18n.t('/Vcr/Autoline/Buy Label') }}</th>
          <th class="r">{{ i18n.t('/Vcr/Autoline/Sell Label') }}</th>
          <th class="r">{{ i18n.t('/Vcr/Autoline/Margin Label') }}</th>
          <th class="r">%</th>
        </tr>
      </thead>
      <tbody v-for="group in groups" :key="group.title" class="vcr-ledger__group">
        <tr class="vcr-ledger__group-header">
          <th colspan="2">{{ group.title }}</th>
          <td v-if="group.rows.length === 0" colspan="4" class="r vcr-ledger__none">
            {{ group.emptyLabel }}
          </td>
          <vcr-ledger-amounts v-else :amounts="group.total" />
        </tr>
        <tr v-for="(row, index) in group.rows" :key="index" class="vcr-ledger__item">
          <td>
            {{ row.label }}
            <small v-if="row.sub">{{ row.sub }}</small>
          </td>
          <td class="vcr-ledger__code">{{ row.code }}</td>
          <td v-if="isIncluded(row)" colspan="4" class="r vcr-ledger__none">
            {{ i18n.t('/Vcr/Autoline/Included Label') }}
          </td>
          <vcr-ledger-amounts v-else :amounts="row" />
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import VcrLedgerAmounts from './VcrLedgerAmounts.vue'

export default {
  components: { VcrLedgerAmounts },
  props: {
    title: { type: String, required: true },
    tag: { type: String, default: '' },
    groups: { type: Array, required: true },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    isIncluded(row) {
      return row.sell === 0 && !row.buy
    },
  },
}
</script>
